import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Eyebrow = ({ children, tone = "blue" }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className={`h-px w-10 ${tone === "green" ? "bg-medgreen" : "bg-medblue"}`} />
    <span className={`text-[10px] uppercase tracking-[0.28em] ${tone === "green" ? "text-medgreen" : "text-medblue"}`}>{children}</span>
  </div>
);

export default function About() {
  return (
    <div data-testid="about-page" className="bg-white">
      <section className="border-b border-rule">
        <div className="container-wide py-20 lg:py-24 max-w-5xl">
          <Eyebrow>About</Eyebrow>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-[68px] leading-[1.03] tracking-tight text-navy">
            A student-first publication about the future of medicine.
          </h1>
          <p className="mt-8 text-lg text-navy/65 max-w-2xl leading-[1.75]">
            Tomorrow&rsquo;s Doctors exists to make healthcare careers more accessible — by connecting students with the
            physicians, researchers, founders, and engineers reshaping medicine today.
          </p>
        </div>
      </section>

      <section className="container-wide py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Eyebrow tone="green">Our Mission</Eyebrow>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-[42px] text-navy leading-[1.15] tracking-tight">
            Bridge the mentorship gap.
          </h2>
        </div>
        <div className="lg:col-span-7 text-[17px] text-navy/70 leading-[1.75] space-y-5">
          <p>Most high school and college students dreaming of healthcare careers never meet a mentor. We interview the people currently shaping medicine and publish those conversations openly.</p>
          <p>No paywalls. No polish. Just the real path — how they got in, what they learned, and what they wish they knew.</p>
        </div>
      </section>

      <section className="bg-parchment py-24">
        <div className="container-wide grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <Eyebrow>Our Vision</Eyebrow>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-[42px] text-navy leading-[1.15] tracking-tight">
              The largest student healthcare education network.
            </h2>
          </div>
          <div className="lg:col-span-7 text-[17px] text-navy/70 leading-[1.75] space-y-5">
            <p>We&rsquo;re building toward a future where any student — anywhere — can access thousands of long-form conversations with the people building the future of medicine.</p>
            <p>Interviews today. Mentorship, research directories, and community tomorrow.</p>
            <div>
              <Link to="/join" className="btn-primary mt-6 inline-flex">Get Involved <ArrowRight size={14} className="ml-2" /></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
